export const updateIntegrationCredentials = /* GraphQL */ `
  mutation UpdateIntegrationCredentials(
    $input: UpdateIntegrationCredentialsInput!
    $condition: ModelIntegrationCredentialsConditionInput
  ) {
    updateIntegrationCredentials(input: $input, condition: $condition) {
      id
      hubSpotAccessToken
      organizationId
      provider
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
